import OBSERVATION_REPORT_DOCUMENTS_STATUS from './observationReportDocumentsStatus';

const OBSERVATION_REPORT_DOCUMENTS_STATUS_MAP = new Map([
  [OBSERVATION_REPORT_DOCUMENTS_STATUS.PENDING_REVIEW, 'Pending Review'],
  [OBSERVATION_REPORT_DOCUMENTS_STATUS.ACCEPTED, 'Accepted'],
  [OBSERVATION_REPORT_DOCUMENTS_STATUS.RETURNED, 'Returned']
]);

export default OBSERVATION_REPORT_DOCUMENTS_STATUS_MAP;
